import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Input } from 'app/components/ui/input';
import { Label } from 'app/components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';
import { FileText, AlertCircle } from 'lucide-react';

interface LicenseSettingsProps {
  form: UseFormReturn<any>;
}

export default function LicenseSettings({ form }: LicenseSettingsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="w-5 h-5" />
          License Information
        </CardTitle>
        <CardDescription>View and manage your license details.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="plan_name">Plan Name</Label>
            <Input
              id="plan_name"
              {...form.register('plan_name')}
              placeholder="Premium"
              disabled
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="license_number">License Number</Label>
            <Input
              id="license_number"
              {...form.register('license_number')}
              placeholder="License number"
              disabled
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="license_start_date">License Start Date</Label>
            <Input
              id="license_start_date"
              type="date"
              {...form.register('license_start_date')}
              disabled
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="license_expiry_date">License Expiry Date</Label>
            <Input
              id="license_expiry_date"
              type="date"
              {...form.register('license_expiry_date')}
              disabled
            />
          </div>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <div className="flex items-center gap-2">
            <AlertCircle className="w-5 h-5 text-yellow-600" />
            <p className="text-sm text-yellow-800 mb-0">
              License information is read-only and managed by the system
              administrator.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
